<template>
    <a-segmented
        :options="computedGenderOptions"
        :value="value"
        @change="handleGenderChange"
        block
        class="custom-segmented"
    >
    </a-segmented>
</template>

<script>
import { GenderEnum } from '@/enums/common.enums';

export default {
    name: 'GenderSelect',
    props: {
        gender: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            required: false,
            default: '100%',
        },
        margin: {
            type: String,
            required: false,
            default: '0px',
        },
        language: {
            type: String,
            required: false,
        },
    },
    computed: {
        computedGenderOptions() {
            return [
                {
                    label: '남',
                    value: GenderEnum.MALE,
                },
                {
                    label: '여',
                    value: GenderEnum.FEMALE,
                },
                {
                    label: '입력 안 함',
                    value: '',
                },
            ];
        },
    },
    data() {
        return {
            GenderEnum,
            value: this.gender,
        }
    },
    watch: {
        gender(newValue) {
            this.value = newValue;
        }
    },
    methods: {
        handleGenderChange(value) {
            this.value = value;
            this.$emit('handle-gender-change', value);
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-segmented {
    :deep {
        .ant-segmented-item-label {
            padding: 4px 0;
            font-size: 14px !important;
            color: #666;
        }

        .ant-segmented-item-selected {
            .ant-segmented-item-label {
                font-weight: 500;
                word-break: break-all !important;
            }
        }
    }
}
</style>

<style lang="scss">
.ant-segmented-item{
    margin-bottom: 0px !important;
}
</style>
